import api from './api';

export default {
  startAuth({
    type, emailAddress, russiaRunningToken, attributes,
  }) {
    return api.post('/identity/api/v1/authentication', {
      type,
      emailAddress,
      russiaRunningToken,
      attributes,
    });
  },
  approveAuth({ token, code }) {
    return api.patch('/identity/api/v1/authentication', {
      token,
      code,
    });
  },
  getProvidersAuth() {
    return api.get('/identity/api/v1/providers/available');
  },
  createAuthRequest({ providerType }) {
    const config = {
      params: { providerType },
    };

    return api.post('/identity/api/v1/extended-authentication', {}, config);
  },
  processAuthRequest({ token, attributes }) {
    return api.patch('/identity/api/v1/extended-authentication/process', {
      token,
      attributes,
    });
  },
  changeEmail({ token, emailAddress }) {
    return api.patch('/identity/api/v1/extended-authentication/change-email', {
      token,
      emailAddress,
    });
  },
  submitCode({ token, code }) {
    return api.patch('/identity/api/v1/extended-authentication/submit-code', {
      token,
      code,
    });
  },
  resendCode({ token }) {
    const config = {
      params: { token },
    };
    return api.patch('/identity/api/v1/extended-authentication/resend-code', {}, config);
  },
  cancelAuthRequest({ token }) {
    const config = {
      params: { token },
    };
    return api.patch('/identity/api/v1/extended-authentication/cancel', {}, config);
  },
};
